import { Divider, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CARDS } from '../../constants/cards';
import { fetchHistory } from '../../store/GenerationSlice';
import { getConversation } from '../../store/ConversationSlice';
import { AppDispatch, RootState } from '../../store/store';
import { CardItem, Generation as GenerationItem, Generations, Mode } from '../../types/common';
import ActionTabs from './ActionTabs';
import GenerateTab from './GenerateTab';
import AIChatTab from './AIChatTab';

const Output: React.FC = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(1);
  const dispatch = useDispatch<AppDispatch>();
  const { url } = useParams();
  const card = CARDS.find((card) => card.url === url) as CardItem;
  const { isHistoryLoading, generations, history, isGenerationLoading } = useSelector(
    (state: RootState) => state.generation
  );
  const generation = (generations[card.mode as keyof Generations] as GenerationItem) || [];
  const historyGenerations = history.map((gen) => gen.texts).flat();
  const { messages, isConversationLoading } = useSelector(
    (state: RootState) => state.conversation
  );

  const handleActionsTabs = (id: number) => {
    setActiveTab(id);
  };

  useEffect(() => {
    if (url === 'chat') {
      dispatch(getConversation());
    }
  }, [])

  useEffect(() => {
    if (isGenerationLoading) {
      setActiveTab(1);
    }
  }, [isGenerationLoading]);

  useEffect(() => {
    if (activeTab === 2) {
      dispatch(fetchHistory(card.mode as Mode));
    }
  }, [activeTab, dispatch, card.mode]);

  return (
    <Stack sx={{ flex: 1, position: 'relative', background: theme.custom.palette.primary.background }}>
      <Divider
        light
        sx={{
          display: { mobile: 'block', laptop: 'none' },
        }}
      />
      <ActionTabs
        onClick={handleActionsTabs}
        activeTab={activeTab}
        isDisabled={isHistoryLoading || isGenerationLoading}
      />
      <Divider light />
      {activeTab === 1 && ( url === 'chat' ? (
        <AIChatTab
          loaderText={'Загружаю...'}
          isLoading={isConversationLoading}
          placeholder={'Здесь будет диалог с AI-помощником'}
          messages={messages || []}
        />
      ) : (
        <GenerateTab
          loaderText={'Генерирую...'}
          isLoading={isGenerationLoading}
          placeholder={'Здесь будет результат генерации'}
          generations={generation.texts || []}
        />
      ))}

      {activeTab === 2 && (
        <GenerateTab
          loaderText={'Загружаю историю...'}
          isLoading={isHistoryLoading}
          placeholder={'Пусто'}
          generations={historyGenerations || []}
        />
      )}
    </Stack>
  );
};

export default Output;
